var defaultStyles = {
  "root": "Base-Badge",
  "number": "Base-Badge--Number",
  "dot": "Base-Badge--Dot",
  "text": "Base-Badge--Text",
  "badge_custom_dot": "Base-Badge--BadgeCustomDot",
  "custom_dot": "Base-Badge--CustomDot",
  "inline_dot": "Base-Badge--InlineDot",
  "label": "Base-Badge--Label",
  "pending": "Base-Badge--Pending",
  "success": "Base-Badge--Success",
  "warning": "Base-Badge--Warning",
  "critical": "Base-Badge--Critical",
  "cancelled": "Base-Badge--Cancelled",
  "new": "Base-Badge--New",
  "bestseller": "Base-Badge--Bestseller",
  "rounded": "Base-Badge--Rounded",
  "scale": "Base-Badge--Scale"
};

export { defaultStyles as default };
